export enum ProgrammeLessonAttendanceStatus {
  Pending = 'Pending',
  Present = 'Present',
  SickLeavePending = 'SickLeavePending',
  SickLeave= 'SickLeave',
  Absent= 'Absent'
}